import { applyMiddleware, compose, createStore, Store } from 'redux';
import rootReducer from './reducers';
import thunk from 'redux-thunk';

let store: Store | null = null;

export default function configureStore(preloadedState?: any): Store {
    if (store) {
        return store;
    }

    const composeEnhancer: typeof compose = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    store = createStore(rootReducer, preloadedState, composeEnhancer(applyMiddleware(thunk)));

    return store;
}

export const getStore = (): Store | null => store;
